import type React from 'react';
import { useTranslation } from 'next-i18next';
import LangMenu from '../../../dropdowns/LangMenu';
import appUtils from '../../../../../../utils/appUtils';

interface Props {
  currentLocale: string;
}

const GuestHeaderDesktopRightPart: React.FC<Props> = ({ currentLocale }) => {
  const { t } = useTranslation('common');
  return (
    <div className="hidden md:ml-6 md:flex md:space-x-8 md:items-center">
      <LangMenu />
      <a
        href={appUtils.getAppPath(currentLocale, 'login')}
        className="text-default hover:text-link font-medium"
      >
        <span>{t('service.header.login')}</span>
      </a>
      <a
        href={appUtils.getAppPath(currentLocale, 'signup')}
        className="text-default"
      >
        <button
          type="button"
          className="relative inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary shadow-sm hover:bg-primary-active focus:outline-none focus:ring-2"
        >
          <span>{t('service.header.signup')}</span>
        </button>
      </a>
    </div>
  );
};

export default GuestHeaderDesktopRightPart;
